'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertErrorTriangleIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _palette = require('../palette');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var AlertErrorTriangleIcon = function AlertErrorTriangleIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? _palette.errorColor : _ref$color,
      _ref$insideColor = _ref.insideColor,
      insideColor = _ref$insideColor === undefined ? _palette.white : _ref$insideColor,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ['color', 'insideColor', 'height', 'width']);

  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 24 24',
    fill: color,
    height: height,
    width: width
  }, props), _react2.default.createElement('g', {
    'data-name': 'Layer 1'
  }, _react2.default.createElement('path', {
    fill: insideColor,
    d: 'M23.43,16.53,15,2.37a3.53,3.53,0,0,0-4.82-1.19A3.48,3.48,0,0,0,9,2.36L.48,16.51a3.5,3.5,0,0,0,1.27,4.8,3.54,3.54,0,0,0,1.71.47h17a3.5,3.5,0,0,0,3-5.25ZM2.5,20a2,2,0,0,0,1,.27A2,2,0,0,1,2.5,20ZM11.87,2.19h0ZM22.25,19a2,2,0,0,0,.15-.78,2.24,2.24,0,0,0-.07-.51,2.24,2.24,0,0,1,.07.51A2,2,0,0,1,22.25,19Z'
  }), _react2.default.createElement('path', {
    d: 'M10.24,3.14,1.77,17.28a2,2,0,0,0,1.71,3H20.42a2,2,0,0,0,2-2,2.09,2.09,0,0,0-.27-1L13.66,3.14a2,2,0,0,0-2.75-.67A2,2,0,0,0,10.24,3.14Z'
  }), _react2.default.createElement('path', {
    fill: insideColor,
    d: 'M12,13.28a1,1,0,0,1-1-1v-4a1,1,0,0,1,2,0v4A1,1,0,0,1,12,13.28Z'
  }), _react2.default.createElement('path', {
    fill: insideColor,
    d: 'M12,17.28a1,1,0,0,1-.38-.07,1.27,1.27,0,0,1-.33-.22,1,1,0,0,1,0-1.42,1,1,0,0,1,.33-.21.93.93,0,0,1,.57-.06.6.6,0,0,1,.19.06.56.56,0,0,1,.17.09l.16.12a1,1,0,0,1,0,1.42.61.61,0,0,1-.16.12,1,1,0,0,1-.17.1l-.19.05A.62.62,0,0,1,12,17.28Z'
  })));
};

exports.AlertErrorTriangleIcon = AlertErrorTriangleIcon;